export const JOB_IDENTITY_OPTIONS = [
  { label: "找实习", value: 1 },
  { label: "找校招", value: 2 },
  { label: "1-3年工作经验", value: 3 },
  { label: "4-7年工作经验", value: 4 },
  { label: "7年以上工作经验", value: 5 },
];

export const SERVICE_FAQ = [
  {
    title: "导师辅导的内容包括哪些？",
    descrpition:
      "<p>超级简历已经为超过 30000 名求职者优化简历，并总结出了一套大幅提高简历成功率的方法论。每一位成功导师皆有5-10年从业经验，并经过平台筛选，确保简历修改的标准。</p><p>自 2020 年 11 月起，导师服务已全面升级，四大服务内容打造一站式绝佳体验，服务内容包括：</p><p><strong>1. 1v1 简历修改：</strong>根据求职意向全方面优化简历的各个维度，并给予详细的修改意见，以及针对找校招和职场人跳槽的求职者，服务会包含一次 30 分钟的微信电话交流服务，导师深度挖掘你的过往经历。</p><p><strong>2.面试辅导：</strong>知名企业资深校招招聘负责人，1V1 语音沟通，60 分钟深度沟通，5 道自选面试问题 +3 道个性化面试题 +2 道预测面试题，为你的 Offer 保驾护航。</p><p><strong>3.职业咨询：</strong>30分钟语音沟通，领域专家答疑解惑，沟通10分钟内不满意可换导师</p><p><strong>4.职业规划：</strong>职业规划师为你解答职业困惑，制定职业发展计划及阶段性目标，打好职场第一步。</p>",
    showDescription: false,
  },
  {
    title: "下单前注意事项？",
    descrpition: `
<p><strong>1. 不作假：</strong>导师辅导服务提供的每一份简历都是最大化体现候选人的亮点进而增加候选人的竞争力，但是必须是真实可信的。根据经验，简历内容超出实际能力的候选人会在面试环节被刷掉。求职要量力而为，最合适的 Offer 才是最好的 Offer，切勿急功近利。</p>
<p><strong>2. 沟通内容：</strong>为了提供准确、有效的求职建议，下单后会要求提供目标岗位的 JD（职位描述）。</p>
<p><strong>3. 其他帮助：</strong>如果有其他需要，如面试辅导、职业规划、行业认知等问题请与导师沟通，导师同意接单后您需额外支付相应服务费用后再进行服务。</p>
<p><strong>4. 不覆盖范畴：</strong>导师服务只针对求职简历辅导。考研、出国、MBA、申请奖项等其他简历使用场景均不属于服务范围内，无法保证此类场景的辅导效果，也无法针对简历以外的文书进行辅导。</p>`,
    showDescription: false,
  },
  {
    title: "导师由谁来担任？",
    descrpition:
      `<p>如果你下单时选择了相应导师，会由该导师为你服务，如果下单时选择的【平台推荐】，下单后联系超级简历助教老师，为你匹配合适的导师，超级简历的导师团队来自高盛、美世咨询、四大、谷歌、BAT、各大 500 强的顶级名企，拥有至少 5 年以上工作经验，并且负责或参与企业招聘流程。</p>`,
    showDescription: false,
  },
  {
    title: "中英文简历为什么会更贵？",
    descrpition:
      "<p>英文简历的市场定价更高，并且全部由英文母语和多年外企工作经验的专家导师修改，所以中英文简历的价格会更贵。</p>",
    showDescription: false,
  },
  {
    title: "多长时间会收到修改回复？",
    descrpition: `
<p>简历优化服务首轮反馈会在 3 天内完成（找实习版本为 3 天内交付终版），并通过微信推送通知。</p>
<p><strong>【找实习】</strong>包括 1 轮简历修改反馈；</p>
<p><strong>【找校招及职场人跳槽】</strong>版本包括 10 天内多轮（每轮 3 天）简历修改、添加导师微信沟通，以及 1 次微信语音沟通。</p>
<p>您还可以根据需求选择面试辅导 &amp; 职业规划服务。【<strong>找校招及职场人跳槽</strong>】需要多轮辅导的版本，在导师交付初稿后，需要您在 7 天内提交修改，超过 7 天未提交修改，导师辅导订单将自动结束。</p>
    `,
    showDescription: false,
  },
  {
    title: "我想要加急怎么办？",
    descrpition: `
<p>您可以在下单前选择是否加急，具体请参照以下表格：</p>
<table dir="ltr" style="width: 16.0258%;" border="0" cellspacing="0" cellpadding="0">
  <colgroup>
    <col width="193" />
    <col width="100" />
    <col width="100" />
    <col width="100" />
  </colgroup>
  <tbody>
    <tr>
      <td style="width: 31.441%;"><strong>套餐/周期</strong></td>
      <td style="width: 27.4802%;"><strong>普通</strong></td>
      <td style="width: 22.3594%;">加急</td>
    </tr>
    <tr>
      <td style="width: 31.441%;"><strong>找实习</strong></td>
      <td style="width: 27.4802%;">3天</td>
      <td style="width: 22.3594%;">24小时</td>
    </tr>
    <tr>
      <td style="width: 31.441%;"><strong>找校招</strong></td>
      <td style="width: 27.4802%;">3天</td>
      <td style="width: 22.3594%;">24小时</td>
    </tr>
    <tr>
      <td style="width: 31.441%;"><strong>职场人跳槽</strong></td>
      <td style="width: 27.4802%;">3天</td>
      <td style="width: 22.3594%;">24小时</td>
    </tr>
  </tbody>
</table>
<p>根据套餐版本及行业选择不同，加急费用为服务基本费用上加价 100～200 元不等</p>
<p>如有特殊需求请联系助教老师沟通。</p>
`,
    showDescription: false,
  },
  {
    title: "如果不用“超级简历”写简历，可以购买导师服务吗？",
    descrpition:
      '<p class="ql-long-15750543"><span class="ql-author-15750543">抱歉，导师辅导只针对在超级简历上制作的简历，建议你用超级简历创建一份简历或将已经写好的简历通过【导入简历】的功能上传。</span></p>\r\n<p class="ql-long-15750543"><span class="ql-author-15750543">另外由于导入功能可能不会100%完全复制您的简历内容，需要您在下单前检查被修改的简历是否完整可读。</span></p>',
    showDescription: false,
  },
  {
    title: "对导师辅导不满意怎么办？",
    descrpition: `
<p>若对导师辅导不满意，可以添加助教老师微信或寻找在线客服及时反馈，我们会帮你与导师协商沟通重新修改或退款。</p>
<p>注意：【找校招】和【职场人跳槽】版本简历优化只在第一轮反馈后提供更换导师或退款服务。</p>
    `,
    showDescription: false,
  },
  {
    title: "我的简历为什么会被退单？",
    descrpition:
      '<p class="ql-long-15750543"><span class="ql-author-15750543">导师辅导下单后首先会进行专业评估，如果简历不完善或存在信息过多缺失，会导致导师无法进行辅导。所以我们会对您的订单发起退款通知。</span></p>\r\n<p class="ql-long-15750543"><span class="ql-author-15750543">建议您在下单之前根据超级简历的填写贴士、案例完善简历，同时注意提交求职意向信息。信息越完整导师越能提供更具针对性的辅导建议。</span></p>',
    showDescription: false,
  },
];

